core.directive('infiniteScroll', ['$timeout',
    function($timeout) {
        var definition = {
            restrict: 'A',
            scope: {
                criteria: '=',
                numberOfPages: '=',
                onNextPage: '&',
                dataLoading: '=',
                container: '=?'
            },
            link: function($scope, element, attr) {

                if($scope.container) {
                    if($scope.container[0] === window) {
                        $scope.elem = angular.element(document.body);
                        $scope.elemContainer = angular.element(window);
                    } else {
                        $scope.elem = $scope.container;
                        $scope.elemContainer = $scope.container;
                    }
                } else {
                    $scope.elem = element;
                    $scope.elemContainer = element;
                }

                function isElementScrolledToBottom (elem, distance) {
                    if(!distance) {
                        distance = 0;
                    }
                    if (elem[0].scrollHeight - distance <= $scope.elemContainer.outerHeight() + elem.scrollTop())
                    {
                        return true;
                    }
                    return false;
                }

                $scope.scrollChanged = function() {
                    if(isElementScrolledToBottom($scope.elem, 100) && $scope.criteria.pageNumber < $scope.numberOfPages - 1 && !$scope.dataLoading) {
                        $scope.criteria.pageNumber++;

                        $scope.onNextPage($scope.criteria);
                    }
                };

                $scope.$watch('dataLoading', function (newVal) {
                    if(!newVal) {
                        $timeout(function () {
                            $scope.scrollChanged();
                        });
                    }
                });

                $scope.elemContainer.scroll(function () {
                    $scope.scrollChanged();
                });

            }
        };

        return definition;
    }
]);